<template>
  <div class="container">
    <div class="title">
      <router-link to="/userCenter">
        <img src="@/assets/images/arrow_left.svg" class="back_btn" />
      </router-link>
      Enterprise information
    </div>
    <div class="user_section">
      <span class="label">Company Name</span>
      <span class="action_btn" @click="companyVisible = true">
        <span class="email">{{ companyInfo.name }}</span>
        <img src="@/assets/images/arrow_right.svg" />
      </span>
    </div>
    <div class="user_section">
      <span class="label">Enterprise certification</span>
      <span class="action_btn" @click="companyInfo.status == 2 ? (verifyVisible = true) : ''">
        {{ companyInfo.status == 2 ? 'Authenticated' : 'Not Authenticated' }}
        <img src="@/assets/images/arrow_right.svg" />
      </span>
    </div>
    <a-modal
      class="user_center_modal"
      title="Company Name"
      v-model:open="companyVisible"
      @cancel="handleCancel"
      :footer="null"
    >
      <a-form ref="formRef" class="modal_form">
        <a-form-item label="Current enterprise：" name="companyName">
          <span class="company_name">{{ companyInfo.name }}</span>
          <span class="change" @click="comfirmVisible = true">Change</span>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal class="user_center_modal" v-model:open="verifyVisible" @cancel="handleVerifyCancel" :footer="null">
      <div class="status_wrapper">
        <img src="@/assets/images/verify_status_success.svg" class="status_icon" alt="" />
        <div class="status_text">Verification successful</div>
        <div class="company_text">
          <div class="title">{{ companyInfo.name }}</div>
          <div class="content">Congratulations on obtaining the enterprise orange logo/identity</div>
        </div>
      </div>
    </a-modal>
    <a-modal class="user_center_modal" v-model:open="comfirmVisible" @cancel="handleComfirmCancel" :footer="null">
      <div class="status_wrapper">
        <img src="@/assets/images/company_comfirm.svg" class="status_icon" alt="" />
        <div class="comfirm_text">
          Changing the enterprise requires re-authentication. Are you sure you want to proceed?
        </div>
        <div class="btn_wrapper">
          <a-button class="cancel_btn" @click="handleComfirmCancel">Cancel</a-button>
          <a-button class="confirm_btn" type="primary" @click.prevent="handleOpenBusinessVerifyModal">
            Confirm
          </a-button>
        </div>
      </div>
    </a-modal>
    <BusinessVerifyModal ref="BusinessVerifyModalRef" @verify_success="handleVerifySuccess" />
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue';

import { fetchCompanySimple, changeCompany } from '@/api/userCenter.js';
import BusinessVerifyModal from '@/components/BusinessVerifyModal.vue';

const companyInfo = reactive({ name: '', status: 0 });
const getCompanyInfo = () => {
  fetchCompanySimple().then((res) => {
    if (res.code == 0 && res.data) {
      companyInfo.name = res.data.name;
      companyInfo.status = res.data.status;
    }
  });
};

const companyVisible = ref(false);
const handleCancel = () => {
  companyVisible.value = false;
};

const verifyVisible = ref(false);
const handleVerifyCancel = () => {
  companyVisible.value = false;
};

const comfirmVisible = ref(true);
const handleComfirmCancel = () => {
  comfirmVisible.value = false;
};

const BusinessVerifyModalRef = ref(null);
const handleOpenBusinessVerifyModal = () => {
  changeCompany({
    name: companyInfo.name,
  }).then((res) => {
    if (res.code == 0) {
      handleComfirmCancel();
      BusinessVerifyModalRef.value.open();
    }
  });
};

const handleVerifySuccess = () => {
  window.location.reload();
};

onMounted(() => {
  getCompanyInfo();
});
</script>

<style lang="less">
.user_center_modal {
  color: #05644f;
  font-size: 16px;
  .ant-modal-content {
    border-radius: 20px;
    padding: 32px;
  }
  .ant-modal-title {
    color: #05644f;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
  }
  .ant-modal-close-icon {
    color: #05644f;
  }
  .modal_form {
    margin-top: 20px;
    .ant-form-item-control {
      display: block;
    }
    .ant-form-item {
      position: relative;
    }
    .ant-input {
      border: 1px solid rgba(5, 100, 79, 0.5);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      padding: 10px;
      font-size: 14px;
      color: #05644f;
    }
    .ant-input-password {
      padding: 0 10px 0 0;
      .ant-input {
        border: none;
      }
    }
    .ant-input::placeholder {
      color: rgba(5, 100, 79, 0.33);
    }
  }
  .btn_wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 20px;
  }
  .confirm_btn,
  .cancel_btn {
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    line-height: normal;
    display: block;
    flex: 1;
    padding: 10px 20px;
    height: auto;
    margin-top: 20px;
    border: none;
    &.cancel_btn {
      background: rgba(5, 100, 79, 0.3);
      color: #fff;
    }
    &:hover {
      background: #05644f;
      color: #fff;
    }
  }
  .change {
    color: #0256ff;
    font-size: 14px;
    font-weight: 500;
    position: absolute;
    right: 0;
    cursor: pointer;
    top: 2px;
  }
  .status_wrapper {
    text-align: center;
    .status_icon {
      margin-top: 24px;
      width: 80px;
      height: 80px;
    }
    .text {
      color: #3d3d3d;
      font-size: 16px;
      margin: 30px auto;
    }
    .status_text {
      font-size: 24px;
      font-weight: bold;
      margin-top: 10px;
    }
    .reason_text {
      text-align: left;
      font-size: 16px;
      font-weight: 500;
      div {
        margin-bottom: 10px;
      }
      .title {
        color: #3d3d3d;
      }
      .content {
        color: #f78335;
      }
      .change_verfify {
        color: #0256ff;
        cursor: pointer;
      }
    }
    .company_text {
      margin: 30px auto;
      font-size: 16px;
      color: #3d3d3d;
      .title {
        font-size: 24px;
      }
    }
  }
  .comfirm_text {
    color: #3d3d3d;
    font-size: 16px;
    margin: 30px auto;
  }
  .company_name {
    width: 300px;
    display: inline-block;
  }
}
</style>

<style lang="less" scoped>
.container {
  position: relative;
  max-width: 850px;
  margin: 0 auto;
  padding-top: 80px;
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #05644f;
    text-align: left;
    .back_btn {
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .user_section {
    margin: 32px auto;
    border-radius: 20px;
    background: #ffffff;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.05);
    padding: 30px;
    position: relative;
    .label {
      color: #3d3d3d;
      font-size: 12px;
    }
    .action_btn {
      margin-left: auto;
      position: absolute;
      right: 30px;
      cursor: pointer;
      top: calc(50% - 10px);
      color: rgba(5, 100, 79, 0.5);
      img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
        vertical-align: text-bottom;
      }
      .email {
        font-size: 12px;
      }
    }
  }
}
</style>
